// URL della Live Chat dell'handover filtrata sul team collegato al bot.
// Restituisce null se manca l'URL base o il team (il bottone non va mostrato).
export function liveChatUrl(handoverUrl, teamId) {
  if (!handoverUrl || !teamId) return null;
  const base = String(handoverUrl).replace(/\/+$/, '');
  if (!base) return null;
  return `${base}/#/app/conversations?team=${encodeURIComponent(teamId)}`;
}
